export class FileSubtitleEntity {
  public description: string;
  public language: string;
  public url: string;
}
